import { calculateTreeProjectProbability, Choices } from '../utils/calculate-tree-project-probability';

export const GLOBAL_REFORESTATION_TREES_TEXT = 'Global reforestation trees';
export const AGROFORESTRY_TREE_PLANTING_TEXT = 'Agroforestry tree planting';
export const LANDSCAPE_RESTORATION_TREE_PLANTING_TEXT = 'Landscape restoration tree planting';

// Agroforestry mix projects
const KENYA_SMALL_HOLDER_FARMERS = 11275;
const KENYA_KAKAMEGA = 11353;

export const agroforestryProjectAllocations: Choices = [
  [KENYA_SMALL_HOLDER_FARMERS, 96.4],
  [KENYA_KAKAMEGA, 3.6],
];

export const agroforestryMix = calculateTreeProjectProbability(agroforestryProjectAllocations);

// Cheap agroforestry mix projects (subset of agroforestry mix)
export const cheapAgroforestryProjectAllocations: Choices = [[KENYA_SMALL_HOLDER_FARMERS, 100]];

export const cheapAgroforestryMix = calculateTreeProjectProbability(cheapAgroforestryProjectAllocations);

// Landscape restoration mix projects
const RESTORING_KAKAMEGA = 11167;
const HIGH_ANDES_POLYLEPIS = 5290;
const GUATEMALA_MANGROVE_RESTORATION = 11256;

export const landscapeRestorationProjectAllocations: Choices = [
  [RESTORING_KAKAMEGA, 6.74],
  [HIGH_ANDES_POLYLEPIS, 4.5],
  [GUATEMALA_MANGROVE_RESTORATION, 88.76],
];

export const landscapeRestorationMix = calculateTreeProjectProbability(landscapeRestorationProjectAllocations);
